import { render, staticRenderFns } from "./EstadoSistema.vue?vue&type=template&id=163df0b0&scoped=true&"
import script from "./EstadoSistema.vue?vue&type=script&lang=js&"
export * from "./EstadoSistema.vue?vue&type=script&lang=js&"
import style0 from "./EstadoSistema.vue?vue&type=style&index=0&id=163df0b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163df0b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VCard,VCol,VContainer,VProgressLinear,VRow})
